import store from '../store/store';

export default () =>
    store.calendarConfiguration &&
    store.calendarConfiguration.WorkingHoursTimeZone &&
    store.calendarConfiguration.WorkingHoursTimeZone.TimeZoneId;
